import React from 'react';

interface DropboxLayoutProps {
  sidebar: React.ReactNode;
  main: React.ReactNode;
  onViewChange?: (view: 'all' | 'favorites' | 'recent' | 'trash') => void;
}

const DropboxLayout: React.FC<DropboxLayoutProps> = ({ sidebar, main, onViewChange }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const handleCollapsedIconClick = (view: 'all' | 'favorites' | 'recent' | 'trash') => {
    if (onViewChange) {
      onViewChange(view);
    }
  };

  return (
    <div className="row dropbox-layout-row">
      <div className={`${sidebarCollapsed ? 'col-md-1' : 'col-md-3'} transition-width dropbox-sidebar-column`}>
        <div className="card dropbox-sidebar-card">
          <div className="card-body p-0 dropbox-sidebar-body">
            <div className="sidebar-toggle-wrapper">
              <button 
                className="btn btn-sm btn-link sidebar-toggle-btn"
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                <i className={`fas fa-${sidebarCollapsed ? 'chevron-right' : 'chevron-left'}`}></i>
              </button>
            </div>
            {!sidebarCollapsed && sidebar}
            {sidebarCollapsed && (
              <div className="sidebar-collapsed-icons">
                <div 
                  className="collapsed-icon" 
                  title="All Files"
                  onClick={() => handleCollapsedIconClick('all')}
                >
                  <i className="fas fa-home"></i>
                </div>
                <div 
                  className="collapsed-icon" 
                  title="Favourites"
                  onClick={() => handleCollapsedIconClick('favorites')}
                >
                  <i className="fas fa-star"></i>
                </div>
                <div 
                  className="collapsed-icon" 
                  title="Recent"
                  onClick={() => handleCollapsedIconClick('recent')}
                >
                  <i className="fas fa-clock"></i>
                </div>
                <div 
                  className="collapsed-icon" 
                  title="Trash"
                  onClick={() => handleCollapsedIconClick('trash')}
                >
                  <i className="fas fa-trash"></i>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={`${sidebarCollapsed ? 'col-md-11' : 'col-md-9'} transition-width dropbox-main-column`}>
        <div className="card dropbox-main-card">
          <div className="card-body dropbox-main-body">{main}</div>
        </div>
      </div>
    </div>
  );
};

export default DropboxLayout;
